import React, { useContext, useEffect, useState } from "react";
import { Table } from "antd";
import { invDepreciationColumns } from "./InvDepreciationColumns";
import { DepreciationReportContext } from "../DepreciationReport";
import { Spinner } from "../../../../app/ui/spinner";

const InventoryDepreciationTable = () => {
  const { state, actions } = useContext(DepreciationReportContext);
  const [filteredData, setFilteredData] = useState([]);
  useEffect(() => {
    if (state.searchStr === "")
      return setFilteredData(state.inventoryReportData);
    const filtered = state.inventoryReportData?.filter((i) => {
      const str = state.searchStr.toLowerCase();
      const name = i?.name.toLowerCase();
      return !!name.includes(str);
    });
    setFilteredData(filtered);
  }, [state.searchStr, state.inventoryReportData]);
  return (
    <Table
      className="ManageInventoryTable"
      style={{ margin: "12px" }}
      size="small"
      columns={invDepreciationColumns(state.categories)}
      dataSource={filteredData}
      rowKey={"id"}
      pagination={{ defaultPageSize: 50 }}
      locale={{ emptyText: "No inventory to show" }}
      scroll={{ y: "calc(100vh - 176px)" }}
    />
  );
};

export default InventoryDepreciationTable;
